"use client"

import { useState, useEffect } from "react"
import { X } from "lucide-react"
import { usePathname } from "next/navigation"

export default function PromoBanner() {
  const [isVisible, setIsVisible] = useState(false)
  const pathname = usePathname()

  // Check if banner should be shown based on URL path, localStorage, and date
  useEffect(() => {
    // Only show on /skola paths
    const shouldShowOnPath = pathname.startsWith("/skola")

    // Check if user has dismissed the banner
    const bannerDismissed = localStorage.getItem("promoBannerDismissed")

    // Check if the promotion period has ended (April 20, 2025)
    const now = new Date()

    // Create date for April 20, 2025 23:59:59 in Sweden time (UTC+2 during April)
    const endDate = new Date("2025-04-20T23:59:59+02:00")

    const promotionActive = now <= endDate

    // Show banner only if it's the right path, not dismissed, and promotion is still active
    setIsVisible(shouldShowOnPath && bannerDismissed !== "true" && promotionActive)
  }, [pathname])

  const dismissBanner = () => {
    setIsVisible(false)
    localStorage.setItem("promoBannerDismissed", "true")
  }

  if (!isVisible) return null

  return (
    <div className="bg-white border-b border-gray-100 py-1.5 text-xs text-gray-500">
      <div className="container mx-auto flex items-center justify-center">
        <p className="text-center">
          Just nu erbjuder vi 15% rabatt till alla nya användare med kod{" "}
          <span className="text-blue-500">APRIL2025</span>. Giltig t.o.m. 20 april.
        </p>
        <button onClick={dismissBanner} className="ml-3 text-gray-300 hover:text-gray-500 bg-white" aria-label="Stäng">
          <X size={12} />
        </button>
      </div>
    </div>
  )
}
